import lod_ from "lodash";
import { queryDictionary } from "helpers/dictionary";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { createDictionarySkeleton } from "helpers/form";
import MDBox from "components/Basics/MDBox";
import { LittleForm } from "components/Custom/LittleForm";

const TabContent = ({ tab, values, displayOnlyExistingValues = false }) => {
	const dispatch = useDispatch();
	const [dictionary, setDictionary] = useState({});
	const [dictionarySkeleton, setDictionarySkeleton] = useState({});

	const codeDictionary = tab?.dictionary || "";
	const field = tab?.field || "";

	const data = lod_.get(values, field, {});

	const fetchDictionary = async () => {
		if (!lod_.isEmpty(codeDictionary)) {
			const result = await queryDictionary(dispatch, codeDictionary);
			if (!lod_.isNil(result)) {
				setDictionary(result);
				setDictionarySkeleton(createDictionarySkeleton(result, data));
				return;
			}
		}

		setDictionary({});
		setDictionarySkeleton({});
	};

	useEffect(() => {
		fetchDictionary();
	}, [dispatch, tab?.name, codeDictionary]);

	if (lod_.isEmpty(tab) || !lod_.isObject(tab)) {
		return null;
	}

	return (
		<MDBox sx={{ flex: 1, overflow: "auto", p: 2.5 }}>
			<LittleForm
				disabled
				object={dictionary?.items ?? {}}
				metadatasSkeleton={dictionarySkeleton}
				handleChange={(path, value) => {}}
				displayOnlyExistingValues={displayOnlyExistingValues}
			/>
		</MDBox>
	);
};

export default TabContent;
